module.exports = __webpack_public_path__ + "static/router@2x-e9457f3d7bf17869a831c22892a38c40.png";